import { Switch } from "@headlessui/react"

type Props = {
  excludedFromDiscounts: boolean
  onExcludedChanged: (isExcluded: boolean) => any
  disabled?: boolean
}

export function CategoryExcludedFromDiscountField({ excludedFromDiscounts, onExcludedChanged, disabled }: Props) {
  return (
    <div className="border-t border-b border-blue-100 py-4 flex flex-col">
      <Switch.Group>
        <div className="flex items-center">
          <Switch.Label
            className="flex-1 cursor-pointer pr-4"
          >
            <div className="text-base font-medium text-blue-500">
              Exclude from discounts
            </div>
            <div className="text-sm font-regular text-gray-500 leading-4 mt-1">
              Products in this category will not be discounted.
            </div>
          </Switch.Label>
          <Switch
            as="div"
            checked={excludedFromDiscounts}
            onChange={(enabled) => {
              if (disabled) {
                return
              }

              onExcludedChanged(enabled)
            }}
            className={`
              ${excludedFromDiscounts ? "bg-blue-500" : "bg-gray-200"}
              relative inline-flex items-center h-8 rounded-full w-14 shadow cursor-pointer
            `}
          >
            <span
              className={`
                ${excludedFromDiscounts ? "translate-x-7" : "translate-x-1"}
                inline-block w-6 h-6 bg-white rounded-full
                transform transition ease-in-out duration-200 shadow
              `}
            />
          </Switch>
        </div>
      </Switch.Group>
    </div>
  )
}
